import React, { useState } from 'react';
// Material UI
import { Button, Grid, Paper, Typography, Box } from "@mui/material"
import FilterListIcon from '@mui/icons-material/FilterList';

// Components
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import Dropdown from "../../../components/inputs/dropdown"
import Searchbox from "../../../components/inputs/searchbox"
import WarehouseAutocomplete from "../../../components/inputs/autocompletes/WarehouseAutocomplete";
import CustomActionBar from '../../../components/CustomActionBarDatePicker'

// Hooks
import { stateFilter } from "../../../models/ReferralEntities"

const ReferralFilters = ({ filters, setFilters, disabledStateFilter, clearFilters }) => {
    const [originSelected, setOriginSelected] = useState(null);
    const [destSelected, setDestSelected] = useState(null);
    const handleFilterChange = (event) =>
        setFilters({ ...filters, [event.target.name]: event.target.value, pageNumber: 1 });

    const handleChangeOrigin = (e, option) => {
        setOriginSelected(option);
        setFilters({ WarehouseOrigenId: option?.id || null, pageNumber: 1 })
    }

    const handleLoadOrigin = (warehouses) => {
        if (!filters.WarehouseOrigenId) return;

        const warehouse = warehouses.find(w => w.id === filters.WarehouseOrigenId);
        setOriginSelected(warehouse);
    }

    const handleChangeDest = (e, option) => {
        setDestSelected(option);
        setFilters({ ...filters, WarehouseDestinationId: option?.id || null, pageNumber: 1 })
    }

    const handleLoadDest = (warehouses) => {
        if (!filters.WarehouseDestinationId) return;

        const warehouse = warehouses.find(w => w.id === filters.WarehouseDestinationId);
        setDestSelected(warehouse);
    }

    return (
        <Box component={Paper} padding={2}>
            <Grid container spacing={1} alignItems="flex-end">
                <Grid
                    size={{
                        xs: 12,
                        sm: 6,
                        md: 4
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary'> Filtrar por remito: </Typography>
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 6
                            }}
                        >
                            <Searchbox
                                fullWidth
                                size='small'
                                name='id'
                                label='Remito'
                                onChange={handleFilterChange}
                                value={filters?.id || ''}
                            />
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 6
                            }}
                        >
                            <Searchbox
                                fullWidth
                                size='small'
                                name='shipmentNumber'
                                label='Nro Envio'
                                onChange={handleFilterChange}
                                value={filters?.shipmentNumber || ''}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                {!disabledStateFilter &&
                    <Grid
                        size={{
                            xs: 12,
                            sm: 6,
                            md: 3,
                            lg: 2
                        }}
                    >
                        <Grid container spacing={1}>
                            <Grid size={12}>
                                <Typography variant='inherit' color='primary'> Filtrar por estado: </Typography>
                            </Grid>
                            <Grid size={12}>
                                <Dropdown
                                    fullWidth
                                    name='state'
                                    label='Estado'
                                    onChange={handleFilterChange}
                                    size='small'
                                    getOptionLabel={(option) => option?.label}
                                    getOptionValue={(option) => option?.value}
                                    value={filters?.state || ''}
                                    values={stateFilter}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                }
                <Grid
                    size={{
                        xs: 12,
                        md: 6,
                        lg: 4
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary' style={{ display: 'block' }}> Filtrar por fecha de creación: </Typography>
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 6
                            }}
                        >
                            <DatePicker
                                label={filters?.from ? 'Desde' : 'dd/mm/aaaa'}
                                value={filters?.from ? dayjs(filters.from) : null}
                                onChange={(newValue) => {
                                    handleFilterChange({
                                        target: {
                                            name: 'from',
                                            value: newValue ? dayjs(newValue).format('YYYY-MM-DD') : ''
                                        }
                                    });
                                }}
                                format="DD/MM/YYYY"
                                slots={{
                                    actionBar: CustomActionBar,
                                }}
                                slotProps={{
                                    actionBar: {
                                        onChange: (newValue) => {
                                            handleFilterChange({
                                                target: {
                                                    name: 'from',
                                                    value: newValue ? dayjs(newValue).format('YYYY-MM-DD') : '',
                                                },
                                            });
                                        },
                                        setOpen: (value) => {
                                            const picker = document.querySelector('[role="dialog"]');
                                            if (picker) picker.style.display = value ? 'block' : 'none';
                                        },
                                    },
                                    textField: {
                                        fullWidth: true,
                                        size: 'small',
                                    },
                                }}
                            />
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 6
                            }}
                        >
                            <DatePicker
                                label={filters?.to ? 'Hasta' : 'dd/mm/aaaa'}
                                value={filters?.to ? dayjs(filters.to) : null}
                                onChange={(newValue) => {
                                    handleFilterChange({
                                        target: {
                                            name: 'to',
                                            value: newValue ? dayjs(newValue).format('YYYY-MM-DD') : '',
                                        },
                                    });
                                }}
                                format="DD/MM/YYYY"
                                slots={{
                                    actionBar: CustomActionBar,
                                }}
                                slotProps={{
                                    actionBar: {
                                        onChange: (newValue) => {
                                            handleFilterChange({
                                                target: {
                                                    name: 'to',
                                                    value: newValue ? dayjs(newValue).format('YYYY-MM-DD') : '',
                                                },
                                            });
                                        },
                                        setOpen: (value) => {
                                            const picker = document.querySelector('[role="dialog"]');
                                            if (picker) picker.style.display = value ? 'block' : 'none';
                                        },
                                    },
                                    textField: {
                                        fullWidth: true,
                                        size: 'small',
                                    },
                                }}
                            />

                        </Grid>

                    </Grid>
                </Grid>
                {!disabledStateFilter &&
                    <Grid
                        size={{
                            xs: 12,
                            md: 6,
                            lg: 8
                        }}
                    >
                        <Grid container spacing={1}>
                            <Grid size={12}>
                                <Typography variant='inherit' color='primary' style={{ display: 'block' }}> Filtrar por depositos: </Typography>
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 6
                                }}
                            >
                                <WarehouseAutocomplete
                                    fullWidth
                                    size='small'
                                    label="Deposito origen"
                                    onChange={handleChangeOrigin}
                                    onLoad={handleLoadOrigin}
                                    value={originSelected || ''}
                                />
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 6
                                }}
                            >
                                <WarehouseAutocomplete
                                    fullWidth
                                    size='small'
                                    label="Deposito destino"
                                    onChange={handleChangeDest}
                                    onLoad={handleLoadDest}
                                    value={destSelected || ''}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                }
                <Box component={Grid} item display='flex' flexGrow={1} alignItems='flex-end' justifyContent='flex-end'>
                    <Button
                        color="primary"
                        variant="outlined"
                        onClick={clearFilters}
                        startIcon={<FilterListIcon />}
                    >
                        Limpiar
                    </Button>
                </Box>
            </Grid>
        </Box>
    );
}

export default ReferralFilters;